<template>
  <Modal @close="closeModal">
    <template v-slot:title>{{ title }}</template>
    <template v-slot:body>
      <form>
        <div class="form-group row my-1">
          <ModalDropdown
            v-model="setBoardingPoint"
            v-bind:id="'boardingPoint'"
            v-bind:label="'Boarding Point'"
            v-bind:dropdown="boardingPoints"
            v-bind:defaultOption="'--select boarding point--'"
            v-bind:defaultValue="''">
            <template v-slot:error>
              <ModalError v-if="errors.boardingPoint" v-bind:error="errors.boardingPoint"/>
            </template>
          </ModalDropdown>
        </div>

        <div class="form-group row my-1">
          <ModalDropdown
            v-model="setDroppingPoint"
            v-bind:id="'droppingPoint'"
            v-bind:label="'Dropping Point'"
            v-bind:dropdown="droppingPoints"
            v-bind:defaultOption="'--select dropping point--'"
            v-bind:defaultValue="''">
            <template v-slot:error>
              <ModalError v-if="errors.droppingPoint" v-bind:error="errors.droppingPoint"/>
            </template>
          </ModalDropdown>
        </div>

        <div class="form-group row my-1">
          <ModalInput
            v-model="localRoute.upFare"
            v-bind:placeholder="'Up Fare'"
            v-bind:label="'Up Fare'"
            v-bind:id="'upFare'"
            v-bind:type="'4digitNumber'"
          >
            <template v-slot:error>
              <ModalError v-if="errors.upFare" v-bind:error="errors.upFare" />
            </template>
          </ModalInput>
        </div>

        <div class="form-group row my-1">
          <ModalInput
            v-model="localRoute.downFare"
            v-bind:placeholder="'Down Fare'"
            v-bind:label="'Down Fare'"
            v-bind:id="'downFare'"
            v-bind:type="'4digitNumber'"
          >
            <template v-slot:error>
              <ModalError v-if="errors.downFare" v-bind:error="errors.downFare" />
            </template>
          </ModalInput>
        </div>

        <div class="form-group row my-1">
          <label class="col-sm-3 col-form-label"></label>
          <div class="col-sm-9">
            <input
              v-if="!boardingPointId && !droppingPointId && !upFareId && !downFareId"
              type="submit"
              value="Submit"
              class="mt-3 py-2 submit_button font_detail float-end"
              @click.prevent="addLocalRoute"
            />
            <input
              v-else
              type="submit"
              value="Submit"
              class="mt-3 py-2 submit_button font_detail float-end"
              @click.prevent="updateLocalRoute"
            />
          </div>
        </div>
      </form>
    
    </template>
  </Modal>
</template>

<script>
import useInputValidation from "@/modules/useInputValidations";
import { inject, onMounted, onBeforeMount, ref, watch } from "vue";
import { reactive } from "@vue/reactivity";
import store from "@/store";
// import { useRoute } from "vue-router";

export default {
  name: "LocalRouteAddUpdateModal",
  props: {
    localRouteObject : Object,
    boardingPlaceforLocalRoutes : String,
    droppingPointforLocalRoutes: String,
    localRoutesUpFare : [String, Number],
    localRoutesDownFare : [String, Number],
    localRoutesID : String,
    routeId : String,
    rId: String
  },
  setup(props, { emit }) {
    let { requiredValidation, errors } = useInputValidation();
    const localRoute = reactive({
      id:"",
      routeId: "",
      companyId: "",
      boardingPlace: "",
      droppingPoint: "",
      upFare: 0,
      downFare: 0,
    });
    const boardingPointId = ref(props.boardingPlaceforLocalRoutes);
    const droppingPointId = ref(props.droppingPointforLocalRoutes);
    const upFareId = ref(props.localRoutesUpFare);
    const downFareId = ref(props.localRoutesDownFare);
    let setBoardingPoint = ref("");
    let setDroppingPoint = ref("");
    let boardingPoints = ref({});
    let droppingPoints = ref({});
    const title = ref("Add Local Route");
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");

    watch(
      () => setBoardingPoint.value,
      (value) => {
        localRoute.boardingPlace = boardingPoints.value[value];
        requiredValidation("name", localRoute.boardingPlace);
      }, {immediate: true}
    );

    watch(
      () => setDroppingPoint.value,
      (value) => {
        localRoute.droppingPoint = droppingPoints.value[value];
        requiredValidation("name", localRoute.droppingPoint);
      }, {immediate: true}
    );

    const validate = () => {
      Object.keys(errors).forEach(function (key) {
        errors[key] = "";
      });
      requiredValidation("boardingPoint", localRoute.boardingPlace);
      requiredValidation("droppingPoint", localRoute.droppingPoint);
      return !(
        Object.values(errors).length <= 0 ||
        !Object.values(errors).every((x) => x === null || x === "")
      );
    };
    const closeModal = () => {
      emit("update:modelValue", false);
    };
    const addLocalRoute = () => {
      if (validate()) {
        showLoader();
        store
          .dispatch("addOwnerServicesLocalRoute", localRoute)
          .then(() => {
            hideLoader();
            emit("getAllLocalRoutes");
            closeModal();
          })
          .catch((error) => {
            hideLoader();
            if (error.status === 401) {
              addLocalRoute();
            }
          });
      }
    };
    const updateLocalRoute = () => {
      if (validate()) {
        showLoader();
        store
          .dispatch("updateOwnerServicesLocalRoute", localRoute)
          .then(() => {
            hideLoader();
            emit("getAllLocalRoutes");
            closeModal();
          })
          .catch((error) => {
            hideLoader();
            if (error.status === 401) {
              updateLocalRoute();
            }
          });
      }
    };
    const initStoppages = () =>{
      boardingPoints.value = {}
      props.localRouteObject.forEach((boardingPoint, index)=>{
        boardingPoints.value[index] = boardingPoint;
      });

      droppingPoints.value = {}
      props.localRouteObject.forEach((droppingPoint, index)=>{
        droppingPoints.value[index] = droppingPoint;
      });
    }

    const findStoppages = (stoppageObject, selectedValue) => {
      return stoppageObject.findIndex(singleStoppage => singleStoppage === selectedValue);
    }

    onMounted(()=>{
      initStoppages();
    })

    onBeforeMount(() => {
      initStoppages();
      Object.keys(errors).forEach(function (key) {
        delete errors[key];
      });
      localRoute.id = props.localRoutesID
      localRoute.routeId = props.rId;
      if (boardingPointId.value!== "" && droppingPointId.value !== "" && upFareId.value !== "" && downFareId.value !== "") {
        title.value = "Update Local Route";
        setBoardingPoint.value = findStoppages(props.localRouteObject, boardingPointId.value);
        setDroppingPoint.value = findStoppages(props.localRouteObject, droppingPointId.value);
        localRoute.upFare = upFareId.value;
        localRoute.downFare = downFareId.value;
      }
    });

    return {
      boardingPointId,
      droppingPointId,
      upFareId,
      downFareId,
      setBoardingPoint,
      boardingPoints,
      setDroppingPoint,
      droppingPoints,
      localRoute,
      errors,
      title,
      addLocalRoute,
      updateLocalRoute,
      closeModal,
    };
  },
};
</script>

<style scoped>
</style>